import { NumberDecimalFormat } from '@components/shared/Format'
import { Constants } from '@models/Constants'
import { Store } from '@stores/Store'

export class DepthCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Depth

  get tPV() {
    const { store } = this
    const { performanceBonusSchedule } = store

    return performanceBonusSchedule[0][0]
  }

  get mdba() {
    const { store } = this
    const { ratioPVBV } = store

    return NumberDecimalFormat(this.tPV * ratioPVBV * Constants.DEEP_BONUS_PERCENT)
  }

  get depthBonus(): number {
    const { store } = this
    const { computedFrontlines } = store

    if (this.depthBonusAllCriteriaMet) {
      const result = computedFrontlines.reduce((cur, { shortage, depthBonusAmount }) => {
        return cur + (shortage + depthBonusAmount)
      }, 0)
      return result < 0 ? 0 : result
    }

    return 0
  }

  get depthBonusAnnual(): number {
    return this.depthBonus * 12
  }

  get depthBonusAllCriteriaMet(): boolean {
    const { depthBonusFrontlineLegsCriteriaMet, depthBonusFrontlineLegsLevelsCriteriaMet } = this
    return depthBonusFrontlineLegsCriteriaMet && depthBonusFrontlineLegsLevelsCriteriaMet
  }

  get depthBonusFrontlineLegsCriteriaMet(): boolean {
    const { store } = this
    const { computedFrontlines } = store

    const result = computedFrontlines.filter((frontline) => frontline.depthBonusLevelCriteriaMet)
    return result && result.length >= Constants.DEEP_BONUS_CRITERIA_MIN_FRONTLINE_LEGS
  }

  get depthBonusFrontlineLegsLevelsCriteriaMet(): boolean {
    const { store } = this
    const { computedFrontlines } = store

    const result = computedFrontlines.filter((frontline) => frontline.depthBonusLegsLevelsCriteriaMet)
    return result && result.length >= Constants.DEEP_BONUS_CRITERIA_MIN_FRONTLINE_LEGS_LEVEL_2
  }

}
